import { useEffect, useState } from "react";

import PropTypes from "prop-types";


import { apiClient, getErrorMessage } from "@/features/shared";
import { useSnackbar } from "@/features/ui";
import { ProductVariantAttributeFormDialog } from "../product-variant-attribute-form-dialog";

import { Button } from "@mui/material";

export const EditProductVariantAttributeFormDialog = ({
  isOpen,
  onClose,
  productVariantAttributeId,
  onSubmitted,
}) => {
  const { showSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(true);
  const [defaultValues, setDefaultValues] = useState(null);

  useEffect(() => {
    if (!isOpen) return;

    const fetchProductVariantAttribute = async () => {
      setIsLoading(true);
      try {
        const {
          data: {
            data: { name, status },
          },
        } = await apiClient.get(
          `product-variant-attributes/${productVariantAttributeId}`
        );
        setDefaultValues({
          name,
          status,
        });
      } finally {
        setIsLoading(false);
      }
    };

    fetchProductVariantAttribute();
  }, [isOpen, productVariantAttributeId]);

  const handleSubmit = async ({ name, status }) => {
    try {
      await apiClient.put(
        `product-variant-attributes/${productVariantAttributeId}`,
        {
          name,
          status,
        }
      );

      onSubmitted();
      onClose();
    } catch (error) {
      showSnackbar(getErrorMessage(error, "Gagal memperbarui atribut varian produk"));

      throw error;
    }
  };

  return (
    <ProductVariantAttributeFormDialog
      isOpen={isOpen}
      onClose={onClose}
      dialogTitle="Ubah Atribut Varian Produk"
      isLoading={isLoading}
      defaultValues={defaultValues}
      onSubmit={handleSubmit}
      renderDialogActionsChildren={({ isLoading }) => (
        <Button loading={isLoading} variant="contained" type="submit">
          Simpan
        </Button>
      )}
    />
  );
};

EditProductVariantAttributeFormDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmitted: PropTypes.func.isRequired,
  productVariantAttributeId: PropTypes.string,
};
